import script from "./MessagesAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./MessagesAnalytics.vue?vue&type=style&index=0&id=c3c62cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3c62cf0"]])

export default __exports__